export default __webpack_public_path__ + "static/restorativ_logo-3e33b66e4096ff7ef73999013571332c.png";